<ul [ngClass]="{ horizontal: horizontal }">
  <li
    *ngFor="let value of options; let valueIndex = index"
    [ngClass]="{ selected: value.selected }"
  >
    <i (click)="selectItem(value[key], valueIndex)"><span></span></i>
    <label for="{{ value[key] }}">{{ value[key] }}</label>
    <input
      type="radio"
      name="{{ radioName }}"
      [(ngModel)]="selected"
      id="{{ value[key] }}"
      value="{{ value[key] }}"
      (ngModelChange)="selectItem(value[key], valueIndex)"
    />
  </li>
</ul>
